import * as Yup from "yup";

export const employeeSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, "Nome muito curto")
        .required("O primeiro nome é obrigatório"),
    lastName: Yup.string()
        .min(2, "Sobrenome muito curto")
        .required("O sobrenome é obrigatório"),
    email: Yup.string()
        .email("E-mail inválido")
        .required("O e-mail é obrigatório"),
    role: Yup.string()
        .required("O cargo é obrigatório"),
    status: Yup.string().oneOf(["active", "inactive", "suspended"]).default("active"),
    phone: Yup.string().nullable(),
    cpf: Yup.string().nullable(),
    photoUrl: Yup.string().nullable(),
    password: Yup.string().when('id', {
        is: (val) => !val,
        then: () => Yup.string().required("Senha é obrigatória para criar acesso").min(6, "A senha deve ter no mínimo 6 caracteres"),
        otherwise: () => Yup.string().nullable()
    }),
    gender: Yup.string().nullable(),
    birthDate: Yup.string().nullable(),
    professionalRegistration: Yup.string().nullable(),
    address: Yup.object().shape({
        zipCode: Yup.string().nullable(),
        state: Yup.string().nullable(),
        city: Yup.string().nullable(),
        neighborhood: Yup.string().nullable(),
        street: Yup.string().nullable(),
        number: Yup.string().nullable()
    }).nullable()
});
